// Libraries
import React, { Fragment, useState } from 'react';
import { Button } from 'react-bootstrap';
// Views
import BulkChangePatientStatusModal from './BulkChangePatientStatusModal';

export const BulkChangePatientStatus = (props) => {
  const {
    selectedPatientsIds, isDisabled, reloadData,
  } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <Fragment>
      <Button
        variant="light"
        className="d-flex-center mr-1"
        onClick={() => setIsModalOpen(true)}
        disabled={(selectedPatientsIds && selectedPatientsIds.size === 0) || isDisabled}
        data-test="bulkChangePatientStatus_changePatientStatusButton"
      >
        <i className="bi-journal-bookmark-fill mr-2" />
        <span className="mb-0">
          <span>Status</span>
        </span>
      </Button>
      <BulkChangePatientStatusModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        selectedPatientsIds={selectedPatientsIds}
        reloadData={reloadData}
      />
    </Fragment>
  );
};

export default BulkChangePatientStatus;
